import React from 'react';
import NavBar from '../Components/NavBar';
import Hero from '../Components/Hero';
import Footer from '../Components/Footer';


export default function Home() {
  return (
    <>
    <NavBar/>
    <Hero/>
    <Footer/>
    </>
  );
}
